import { Controller } from "@hotwired/stimulus"

// three_flyin: Section fades in (title, subtitle, headers visible).
// Each subtext flies in individually when it enters the viewport.

export default class extends Controller {
  static targets = ["subtext"]
  static values = {
    stagger: { type: Number, default: 200 }
  }

  connect() {
    this.element.classList.add("animate-hidden")

    this.sectionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.element.classList.remove("animate-hidden")
          this.element.classList.add("animate-fade-in")
          this.sectionObserver.unobserve(this.element)
          this.observeSubtexts()
        }
      })
    }, { threshold: 0.15, rootMargin: "0px 0px -50px 0px" })

    this.sectionObserver.observe(this.element)
  }

  disconnect() {
    if (this.sectionObserver) this.sectionObserver.disconnect()
    if (this.subtextObserver) this.subtextObserver.disconnect()
  }

  observeSubtexts() {
    this.subtextObserver = new IntersectionObserver(entries => {
      // Collect all newly visible entries and sort by DOM order
      const visible = entries
        .filter(e => e.isIntersecting)
        .sort((a, b) => this.subtextTargets.indexOf(a.target) - this.subtextTargets.indexOf(b.target))

      visible.forEach((entry, i) => {
        setTimeout(() => {
          entry.target.classList.add("three-flyin-subtext-visible")
        }, i * this.staggerValue)
        this.subtextObserver.unobserve(entry.target)
      })
    }, { threshold: 0.5, rootMargin: "0px 0px -30px 0px" })

    this.subtextTargets.forEach(el => this.subtextObserver.observe(el))
  }
}
